import { Expose } from 'class-transformer';

export class InternalWorkTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;

  @Expose()
  isDeleted: Date;
}
